import { createFileRoute, Outlet, Navigate, useRouter } from '@tanstack/react-router'
import { useEffect, useState } from 'react'

import { MainLayout } from '@/components/layout/main-layout'
import { useCurrentUser } from '@/hooks'
import { setAuthToken } from '@/lib/auth-token'

/**
 * 受保护路由布局
 * - 处理 URL 中的 token 参数（OAuth 回调）
 * - 未认证用户重定向到登录页
 * - 已认证用户显示主布局
 */
export const Route = createFileRoute('/_authenticated')({
  component: AuthenticatedLayout,
})

function AuthenticatedLayout() {
  const { data, isLoading, isError, refetch } = useCurrentUser()
  const [isProcessingToken, setIsProcessingToken] = useState(true)
  const router = useRouter()

  const isAuthenticated = !!data && !isError

  // 处理 URL 中的 token 参数（OAuth 回调）
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const token = urlParams.get('token')

    if (token) {
      // 保存 token 到 localStorage
      setAuthToken(token)
      // 清除 URL 中的 token 参数
      urlParams.delete('token')
      const newSearch = urlParams.toString()
      const newUrl = window.location.pathname + (newSearch ? `?${newSearch}` : '')
      window.history.replaceState({}, '', newUrl)
      // 重新检查认证状态
      void refetch().then(() => {
        setIsProcessingToken(false)
        void router.invalidate()
      })
    } else {
      setIsProcessingToken(false)
    }
  }, [refetch, router])

  if (isLoading || isProcessingToken) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-muted-foreground">加载中...</div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" search={{ token: undefined, error: 'auth_check_failed' }} />
  }

  return (
    <MainLayout>
      <Outlet />
    </MainLayout>
  )
}
